import React, { useMemo } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Box } from '@mui/material';

interface RichTextEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  minHeight?: string;
}

const RichTextEditor: React.FC<RichTextEditorProps> = ({
  value,
  onChange,
  placeholder = 'Enter text...',
  disabled = false,
  minHeight = '200px',
}) => {
  // Configure the toolbar with formatting options
  const modules = useMemo(
    () => ({
      toolbar: [
        [{ header: [1, 2, 3, false] }],
        ['bold', 'italic'],
        [{ font: [] }],
        [{ size: ['small', false, 'large', 'huge'] }],
        ['clean'],
      ],
    }),
    []
  );

  const formats = [
    'header',
    'bold',
    'italic',
    'font',
    'size',
  ];

  return (
    <Box
      sx={{
        '& .quill': {
          fontFamily: 'var(--theo-font-sans)',
        },
        '& .ql-container': {
          fontFamily: 'var(--theo-font-sans)',
          fontSize: 16,
          minHeight,
          borderBottomLeftRadius: 6,
          borderBottomRightRadius: 6,
          border: '1px solid #ccc',
          borderTop: 'none',
          '& .ql-editor': {
            fontFamily: 'var(--theo-font-sans)',
            fontSize: 16,
            '&.ql-blank::before': {
              fontFamily: 'var(--theo-font-sans)',
              fontStyle: 'normal',
              color: '#999',
            },
          },
        },
        '& .ql-toolbar': {
          borderTopLeftRadius: 6,
          borderTopRightRadius: 6,
          border: '1px solid #ccc',
          borderBottom: 'none',
          backgroundColor: '#f8f9fa',
        },
      }}
    >
      <ReactQuill
        theme="snow"
        value={value || ''}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
        readOnly={disabled}
      />
    </Box>
  );
};

export default RichTextEditor;

